<template>
  <div class="template" v-if="newAllBetEvent.od[plytyp]">
    <div v-for="btype in btypes" v-if="newAllBetEvent.od[plytyp][btype]" data-template="template4" class="wrap-template template4">
      <div class="vrow items-center template-title is_fold" style="width:100%">
        <div class="play-name col" @click="showLeg()">
          <span class="ellipsis">{{ getTitleCaption() }}</span>
        </div>
        <div style="width: 37px;" @click="setToTop($event)">
          <span class="set_top" style="display: none;">
            <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
          </span>
        </div>
      </div>
      <template v-if="show">
        <div>
          <div class="handicap-sub-title" style="max-height: unset;">
            <!-- A -->
            <div class="flex-1 overflow-hidden part-left">
              <div class="sub-title ellipsis" v-html="newAllBetEvent.tacapt"></div>
              <div class="handicap">
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">1 - 0</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od10'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod10" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">2 - 0</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od20'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod20" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">2 - 1</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od21'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod21" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">3 - 0</span>
                          </div>
                        </div>
                      </div>
                          <cstgftht :event="newAllBetEvent" :score="'od30'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod30" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">3 - 1</span>
                          </div>
                        </div>
                      </div>
                          <cstgftht :event="newAllBetEvent" :score="'od31'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod31" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">3 - 2</span>
                          </div>
                        </div>
                      </div>
                          <cstgftht :event="newAllBetEvent" :score="'od32'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod32" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">4 - 0</span>
                          </div>
                        </div>
                      </div>
                          <cstgftht :event="newAllBetEvent" :score="'od40'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod40" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">4 - 1</span>
                          </div>
                        </div>
                      </div>
                          <cstgftht :event="newAllBetEvent" :score="'od41'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod41" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">4 - 2</span>
                          </div>
                        </div>
                      </div>
                          <cstgftht :event="newAllBetEvent" :score="'od42'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod42" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">4 - 3</span>
                          </div>
                        </div>
                      </div>
                          <cstgftht :event="newAllBetEvent" :score="'od43'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod43" :mode="'ab'" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Draw -->
            <div class="flex-1 overflow-hidden part-middle">
              <div class="sub-title ellipsis">{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}</div>
              <div class="handicap">
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">0 - 0</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od00'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod00" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">1 - 1</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od11'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod11" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">2 - 2</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od22'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod22" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">3 - 3</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od33'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod33" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">4 - 4</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od44'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod44" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-undefined"></div>
                <div class="handicap-item os-undefined"></div>
                <template v-if="plytyp != firstHtPlyType">
                  <div class="handicap-item os-undefined"></div>
                  <div class="handicap-item os-undefined"></div>
                  <div class="handicap-item os-undefined"></div>
                </template>
              </div>
            </div>
            <!-- B -->
            <div class="flex-1 overflow-hidden part-right">
              <div class="sub-title ellipsis" v-html="newAllBetEvent.tbcapt"></div>
              <div class="handicap">
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">0 - 1</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od01'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod01" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">0 - 2</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od02'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod02" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">1 - 2</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od12'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod12" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">0 - 3</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od03'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod03" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">1 - 3</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od13'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod13" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">2 - 3</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od23'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod23" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">0 - 4</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od04'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod04" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">1 - 4</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od14'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod14" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">2 - 4</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od24'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod24" :mode="'ab'" />
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1" v-if="plytyp != firstHtPlyType">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="bet-ellipsis ellipsis">
                            <span class="bet_handicap yb-family-odds">3 - 4</span>
                          </div>
                        </div>
                      </div>
                      <cstgftht :event="newAllBetEvent" :score="'od34'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod34" :mode="'ab'" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="other-item">
            <div class="placehold">
              <div class="empty"></div>
            </div>
            <div class="placehold">
              <div class="empty"></div>
            </div>
            <div class="placehold other no_border_bottom os-1">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet_handicap ellipsis" style="margin-left: 12px;">
                      {{ sportAllBetLang['ALL_BET.LBL_AOS'] }}
                    </div>
                  </div>
                  <cstgftht :event="newAllBetEvent" :score="'aos'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamodaos" :mode="'ab'" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().csBetType, allBetMixin.data().rcsBetType],
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    },
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = 'FT'
      var b = ''
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H'
      }

      // if (this.bettype == this.hdpBetType) {
      b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_CS']
      // } else if (this.bettype == this.bttsBetType) {
      //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
      // }

      // RB score
      // if (this.newAllBetEvent.event_rb == 1) {
      //   b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
      // }
      return b
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
    },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-cs.vue